import { VideoPlayer } from './video-player.interface';

function extractDailymotionId(url: string): string {
    const m = url.match(/(?:video|dai\.ly)\/([A-Za-z0-9]+)/);
    return m ? m[1] : '';
}

export class DailymotionVideoPlayer implements VideoPlayer {
    private iframe: HTMLIFrameElement;
    private msgHandler: (e: MessageEvent) => void;
    private playCb: () => void;
    private pauseCb: () => void;
    private endedCb: () => void;
    private _position = 0;

    async load(container: HTMLElement, url: string, startPosition: number): Promise<void> {
        const id = extractDailymotionId(url);
        const startParam = startPosition > 0 ? `&start=${Math.floor(startPosition)}` : '';
        this.iframe = document.createElement('iframe');
        this.iframe.src = `https://www.dailymotion.com/embed/video/${id}?api=postMessage${startParam}`;
        this.iframe.allow = 'autoplay';
        this.iframe.style.width = '100%';
        this.iframe.style.aspectRatio = '16/9';
        this.iframe.frameBorder = '0';
        container.appendChild(this.iframe);

        this.msgHandler = (e: MessageEvent) => this.handleMessage(e);
        window.addEventListener('message', this.msgHandler);
    }

    private handleMessage(e: MessageEvent): void {
        if (!e.data || typeof e.data !== 'string') return;
        try {
            const data = JSON.parse(e.data);
            if (data.event === 'timeupdate') this._position = data.time ?? this._position;
            if (data.event === 'play' && this.playCb) this.playCb();
            if (data.event === 'pause' && this.pauseCb) this.pauseCb();
            if (data.event === 'end' && this.endedCb) this.endedCb();
        } catch {}
    }

    async getPosition(): Promise<number> {
        return this._position;
    }

    async pause(): Promise<void> {
        this.iframe?.contentWindow?.postMessage('{"command":"pause"}', '*');
    }

    destroy(): void {
        if (this.msgHandler) window.removeEventListener('message', this.msgHandler);
        this.iframe?.remove();
    }

    onPlay(cb: () => void): void { this.playCb = cb; }
    onPause(cb: () => void): void { this.pauseCb = cb; }
    onEnded(cb: () => void): void { this.endedCb = cb; }
}
